import React from "react";
import { RCCAlert, RCCGrid, RCCHidden} from "react-common-components";
import FadedDiv from "src/components/Animations/fade";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import ContainerValues, { ColumnFlex, ContainerUser, SpanComment } from "src/pages/Actions/Panel/components/History/styles";
import formatDate from "src/utils/formatDate";
import { IHistoric } from "../../interface";

export interface IListHistoric {
  data: IHistoric[];
}

const ListHistoric: React.FC<IListHistoric> = ({
	data
}) => {
	const {translate, currentLanguage} = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	return(
		<>
			{!data || data.length === 0 ? (
				<RCCAlert description={translate("Não há nenhum histórico")} />
			) : (
				<InfiniteScrollWithoutFetch 
					listElements={data}
					mapper={(ocb003: IHistoric) => (
						<RCCGrid
							key={ocb003.ocb003Id}
							container
							item
							direction="column"
						>
							<div style={{display: "flex", alignItems: "center", position: "relative"}}>
								<Photo 
									hover={false}
									name={ocb003.ocb003Efa005Nome}
									link={ocb003.ocb003Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${ocb003.ocb003Efa005Imagem}`}
									width={40}
									height={40}
								/>
								<ColumnFlex>
									<ContainerUser>
										<Title color="purple" size="md" styleInline="margin: 2px 5px 2px 5px;">
											{ocb003.ocb003Efa005Nome}
										</Title>
										<Title color="grey" size="xs" styleInline="margin: 2px 5px 2px 5px;">
											{formatDate(ocb003.ocb003DataHora, currentLanguage, true)}
										</Title>
									</ContainerUser>
									<ContainerValues>
										<RCCHidden only="xs">
											<Title color="grey" size="xs" styleInline="margin: 2px 5px 2px 5px;">
												{translate("Etapa")}: {translate(ocb003.step)}
											</Title>
											<Title color="grey" size="xs" styleInline="margin: 2px 5px 2px 5px;">
												{translate("Status")}: {translate(ocb003.status)}
											</Title>
										</RCCHidden>
									</ContainerValues>
									<FadedDiv>
										<SpanComment>
											{ocb003.ocb003Comentario}
										</SpanComment>
									</FadedDiv>
								</ColumnFlex>
							</div>
						</RCCGrid>
					)}
				/>
			)}
		</>
	);
};


export default ListHistoric;
